// extracted by mini-css-extract-plugin
module.exports = {"h3":"DeclarationHeader-module__h3___3QDts","edit-icon":"DeclarationHeader-module__edit-icon___2eU-p","editIcon":"DeclarationHeader-module__edit-icon___2eU-p"};